import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const RegisterPage = () => {
  const navigate = useNavigate();
  const { register, loading } = useUser();
  
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    agreeTerms: false,
  });
  
  const [error, setError] = useState('');
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // 基本验证
    if (!formData.username || !formData.email || !formData.password || !formData.confirmPassword) {
      setError('请填写所有必填项');
      return;
    }
    
    if (formData.password !== formData.confirmPassword) {
      setError('两次输入的密码不一致');
      return;
    }
    
    if (!formData.agreeTerms) {
      setError('请阅读并同意天道宗门规和隐私政策');
      return;
    }
    
    try {
      const result = await register(formData.username, formData.password, formData.email);
      
      if (result.success) {
        // 注册成功，重定向到仪表板
        navigate('/dashboard');
      } else {
        setError(result.error || '注册失败，请重试');
      }
    } catch (err) {
      setError('注册过程中发生错误: ' + err.message);
    }
  };
  
  return (
    <div className="max-w-md mx-auto">
      <div className="cyber-panel p-8 rounded-lg">
        <h1 className="text-3xl font-xianxia text-cyber-primary text-center mb-6 cyber-title">
          加入天道宗
        </h1>
        
        {error && (
          <div className="bg-red-900 bg-opacity-50 border border-red-700 text-red-100 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="username" className="block text-cyber-light mb-2">
              道号/用户名 <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className="w-full bg-cyber-dark border border-cyber-primary text-cyber-light px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-cyber-accent"
              placeholder="请输入您的道号或用户名"
            />
          </div>
          
          <div className="mb-4">
            <label htmlFor="email" className="block text-cyber-light mb-2">
              电子邮箱 <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full bg-cyber-dark border border-cyber-primary text-cyber-light px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-cyber-accent"
              placeholder="请输入您的电子邮箱"
            />
          </div>
          
          <div className="mb-4">
            <label htmlFor="password" className="block text-cyber-light mb-2">
              密码 <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full bg-cyber-dark border border-cyber-primary text-cyber-light px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-cyber-accent"
              placeholder="请设置您的密码"
            />
          </div>
          
          <div className="mb-6">
            <label htmlFor="confirmPassword" className="block text-cyber-light mb-2">
              确认密码 <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="w-full bg-cyber-dark border border-cyber-primary text-cyber-light px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-cyber-accent"
              placeholder="请再次输入密码"
            />
          </div>
          
          <div className="mb-6">
            <label className="flex items-center">
              <input
                type="checkbox"
                name="agreeTerms"
                checked={formData.agreeTerms}
                onChange={handleChange}
                className="mr-2"
              />
              <span className="text-cyber-light text-sm">
                我已阅读并同意{' '}
                <Link to="#" className="text-cyber-primary hover:text-cyber-accent transition duration-300">
                  天道宗门规
                </Link>{' '}
                和{' '}
                <Link to="#" className="text-cyber-primary hover:text-cyber-accent transition duration-300">
                  隐私政策
                </Link>
              </span>
            </label>
          </div>
          
          <button
            type="submit"
            className="cyber-button w-full py-2 text-lg"
            disabled={loading}
          >
            {loading ? '正在注册...' : '注册'}
          </button>
        </form>
        
        <div className="mt-4 text-center">
          <p className="text-cyber-light">
            已经是宗门弟子？{' '}
            <Link to="/login" className="text-cyber-primary hover:text-cyber-accent transition duration-300">
              立即登录
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
